/**
 * @author xiaohuangmao
 * @description 查看经销商
 * @Date 2020/1/2
 */
import React from 'react';
import { connect } from 'dva';
import { Descriptions } from 'antd';
import moment from 'moment'
import { framework_tool, component_tool, utils_tool } from '@/tool'
import columns from "./columns";
const { WizContainer, modelUtils } = framework_tool;
const { WizCard, WizSpin, WizDataTable } = component_tool;
const { Session, getPageData } = utils_tool

class DealerInfoDetail extends WizContainer {

  componentName = 'DealerInfoDetail';

  constructor(props) {
    super(props);
    const { history } = props;
    let dealerInfoDetail = {};
    if (history.location && history.location.pathname === '/org/dealer/dealerInfoDetail') {
      if (history.location && history.location.record) {
        dealerInfoDetail = history.location.record;
        Session.set('dealerInfoDetail', dealerInfoDetail)
      } else {
        dealerInfoDetail = Session.get('dealerInfoDetail') || {};
      }
    }
    this.dealerInfoDetail = dealerInfoDetail;
  }

  _componentDidMount() {
    this._getData()
  }

  _getData = (other = {}) => {
    this.doActions([
      {
        path: 'dealer/look',
        payload: {
          key: 'lookKey',
          apiParams: { id: this.dealerInfoDetail.id, ...other }
        },
        requireLoading: true
      }
    ])
  }

  _getType = type => {
    let _type = ''
    switch (type) {
      case 0:
        _type = '无'
        break;
      case 1:
        _type = '经销商'
        break;
      case 2:
        _type = '服务商'
        break;
      case 99:
        _type = '暂定'
        break;
    }
    return _type
  }

  _getState = state => {
    let _state = ''
    switch (state) {
      case 0:
        _state = '已关店'
        break;
      case 1:
        _state = '已开店'
        break;
      case 2:
        _state = '建设中'
        break;
    }
    return _state
  }

  getParentName = orgFullName => {
    let result = ''
    if(orgFullName) {
      let orgName = orgFullName.split('>')
      result = orgName.slice(0, orgName.length -1).join('>');
    }
    return result
  }

  _render() {
    const { list, dealerLoading } = this.props
    const items = this.dealerInfoDetail;
    const dataItems = getPageData({ records: list.data })
    const dataTableProps = {
      columns,
      rowKey: 'id',
      dataItems
    }

    return (
      <React.Fragment>
        <WizCard title="经销商信息">
          <Descriptions column={2} style={{ paddingLeft: 25 }}>
            <Descriptions.Item label='经销商名称'>{items.name}</Descriptions.Item>
            <Descriptions.Item label='经销商简称'>{items.shortName}</Descriptions.Item>
            <Descriptions.Item label='销售代码'>{items.preSalesNumber}</Descriptions.Item>
            <Descriptions.Item label='售后代码'>{items.afterSalesNumber}</Descriptions.Item>
            <Descriptions.Item label='上级组织' span={2}>{this.getParentName(items.orgName)}</Descriptions.Item>
            <Descriptions.Item label='站点类型'>{this._getType(items.type)}</Descriptions.Item>
            <Descriptions.Item label='ASC编码'>{items.state}</Descriptions.Item>
            <Descriptions.Item label='开店状态'>{this._getState(items.state)}</Descriptions.Item>
            <Descriptions.Item label='开店时间'>{moment(items.openTime).format('YYYY-MM-DD')}</Descriptions.Item>
            <Descriptions.Item label='省份'>{items.province}</Descriptions.Item>
            <Descriptions.Item label='城市'>{items.city}</Descriptions.Item>
            <Descriptions.Item label='地址' span={2}>{items.region} {items.address}</Descriptions.Item>
            <Descriptions.Item label='所属集团' span={2}>{items.bloc}</Descriptions.Item>
            <Descriptions.Item label='备注' span={2}>{items.remark}</Descriptions.Item>
          </Descriptions>
        </WizCard>

        {/* <WizCard title="共建经销商">
          <WizSpin tip={"加载中"} spinning={dealerLoading}>
            <WizDataTable {...dataTableProps} />
          </WizSpin>
        </WizCard> */}
      </React.Fragment>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const { dealer } = state;
  const list = modelUtils.getModelEntity(dealer, "lookKey");
  const load = modelUtils.getLoadingState(state, "dealer");
  return {
    list,
    ...load
  };
};

export default connect(mapStateToProps)(DealerInfoDetail);
